export default __webpack_public_path__ + "static/media/people_icon_circle.c9efd333.png";